export const setCategories = (payload) => {
    return {
        type:"SET_CATEGORIES",
        payload
    }
}